import { VALIDATION_RULES, MOVEMENT_NATURES } from '../constants/movementTypesConstants';

/**
 * Valida los datos de un tipo de movimiento
 * @param {Object} movementTypeData - Datos del tipo de movimiento a validar
 * @returns {Object} - Objeto con los errores de validación
 */
export const validateMovementType = (movementTypeData) => {
  const errors = {};

  // Validar campos requeridos
  VALIDATION_RULES.REQUIRED_FIELDS.forEach((field) => {
    if (!movementTypeData[field] || movementTypeData[field].toString().trim() === '') {
      errors[field] = `El campo es obligatorio`;
    }
  });

  // Validar descripción específicamente
  if (movementTypeData.description) {
    const description = movementTypeData.description.trim();

    if (description.length < VALIDATION_RULES.MIN_LENGTHS.description) {
      errors.description = `La descripción debe tener al menos ${VALIDATION_RULES.MIN_LENGTHS.description} caracteres`;
    }

    if (description.length > VALIDATION_RULES.MAX_LENGTHS.description) {
      errors.description = `La descripción no puede tener más de ${VALIDATION_RULES.MAX_LENGTHS.description} caracteres`;
    }
  }

  // Validar naturaleza
  if (
    movementTypeData.nature &&
    !Object.values(MOVEMENT_NATURES).includes(movementTypeData.nature)
  ) {
    errors.nature = 'La naturaleza debe ser "debit" o "credit"';
  }

  return errors;
};

/**
 * Prepara los datos del tipo de movimiento para envío a la API
 * @param {Object} movementTypeData - Datos del tipo de movimiento
 * @returns {Object} - Datos preparados para la API
 */
export const prepareMovementTypeData = (movementTypeData) => {
  const cleanedData = { ...movementTypeData };

  // Limpiar campos de texto
  if (cleanedData.description) {
    cleanedData.description = cleanedData.description.trim();
  }

  if (cleanedData.display_in_orders !== undefined) {
    cleanedData.display_in_orders = Boolean(cleanedData.display_in_orders);
  }

  if (cleanedData.is_bank_movement_type !== undefined) {
    cleanedData.is_bank_movement_type = Boolean(cleanedData.is_bank_movement_type);
  }

  // Remover campos vacíos o null
  Object.keys(cleanedData).forEach((key) => {
    if (cleanedData[key] === '' || cleanedData[key] === null) {
      delete cleanedData[key];
    }
  });

  return cleanedData;
};
